import { UniFiCategoryId, UniFiChildCategorySlug } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";
import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/Assets-V4/WiFi/u6-mesh-pro@2x.jpg";
import v3Image from "../../assets/Flagship/u6MeshPro.jpg";
import type { Product } from "../../types";
import { wifiOutdoor } from "../product-list-groups/wifi-outdoor";
import { extendedRangeMode6Ghz, radio6Ghz, wifiMounting } from "../properties";
import { antennaType } from "../properties/antennaType";
import { connectedDevices } from "../properties/connectedDevices";
import { wifiCoverage } from "../properties/coverage";
import { externalAntennaSupport } from "../properties/externalAntennaSupport";
import { uplink } from "../properties/uplink";
import { wifiTechnology } from "../properties/wifiTechnology";

export const u6MeshPro: Product = {
  id: "u6MeshPro",
  productTitle: "U6 Mesh Pro",
  techspecsPath: [
    SiteId.TechSpecs,
    `/unifi/${UniFiCategoryId.WiFi}/u6-mesh-pro`,
  ],
  storePathParts: {
    productSlug: "u6-mesh-pro",
    category: UniFiChildCategorySlug.WiFiOutdoor,
  },
  sku: "U6-Mesh-Pro",
  description: "u6MeshPro.description",
  image: { src: image, width: 200, height: 160 },
  v3Image: {
    src: v3Image,
    width: 250,
    height: 182,
  },
  productListGroup: wifiOutdoor,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '343.2 x 181.2 x 60.2 mm\n(13.5 x 7.1 x 2.4")',
      },
    },
    {
      propertyId: wifiTechnology.id,
      value: {
        type: "translation",
        value: "u6MeshPro.wifiTechnology",
      },
    },
    {
      propertyId: radio6Ghz.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: extendedRangeMode6Ghz.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: antennaType.id,
      value: {
        type: "translation",
        value: "antennaType.omnidirectional",
      },
    },
    {
      propertyId: wifiCoverage.id,
      value: { type: "string", value: "185 m² (2,000 ft²)" },
    },
    {
      propertyId: connectedDevices.id,
      value: { type: "string", value: "250+" },
    },
    {
      propertyId: externalAntennaSupport.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "powerMethodPoe",
      value: { type: "string", value: "PoE" },
    },
    {
      propertyId: uplink.id,
      value: { type: "string", value: "GbE" },
    },
    {
      propertyId: wifiMounting.id,
      value: {
        type: "translation",
        value: "commons.mounting.wallPole",
      },
    },
    // MUST HAVE FOR OVERVIEW SECTION
    {
      propertyId: "radios",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "rfFilteringTechnology",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "weatherproofing",
      value: { type: "string", value: "IPX6" },
    },
    {
      propertyId: "redundantRj45Port",
      value: { type: "boolean", value: false },
    },
  ],
};
